export const uploadFileToBucket = ({
  file,
  signedUrl,
  onUploadProgress,
}: {
  file: File;
  signedUrl: string;
  onUploadProgress: (progress: number) => void;
}) => {
  const xhr = new XMLHttpRequest();

  xhr.upload.addEventListener('progress', (event) => {
    if (event.lengthComputable) {
      onUploadProgress((event.loaded / event.total) * 100);
    }
  });
  xhr.open('PUT', signedUrl, true);

  file.arrayBuffer().then((buffer) => {
    xhr.send(buffer);
  });
};
